import React, { useEffect, useRef, useState, useCallback } from 'react';
import img_walk_peopel2 from '../../images/walk_peopel2.webp';

// Pre-calculated top-edge Y coordinate (in % from top of image) across 101 points (0% to 100% horizontal)
const CURVE_POINTS = [
  49.47, 47.69, 45.73, 44.13, 42.35, 40.75, 39.15, 37.72, 36.12, 34.88,
  33.45, 32.21, 30.96, 29.72, 28.47, 27.58, 26.33, 25.44, 24.38, 23.49,
  22.60, 21.71, 21.00, 20.11, 19.40, 18.68, 17.97, 17.44, 16.73, 16.19,
  15.66, 15.12, 14.77, 14.23, 13.70, 13.35, 12.99, 12.63, 12.28, 12.10,
  11.74, 11.57, 11.39, 11.21, 11.03, 10.85, 10.68, 10.50, 10.50, 10.32,
  10.14, 10.14,  9.96,  9.96,  9.96,  9.96,  9.79,  9.79,  9.79,  9.79,
   9.79,  9.79,  9.96,  9.96,  9.96, 10.14, 10.14, 10.32, 10.32, 10.50,
  10.68, 10.85, 11.03, 11.21, 11.39, 11.57, 11.74, 11.92, 12.10, 12.46,
  12.63, 12.99, 13.35, 13.52, 13.88, 14.23, 14.59, 14.95, 15.30, 15.66,
  16.19, 16.55, 17.08, 17.62, 17.97, 18.51, 19.04, 19.57, 20.11, 20.82,
  21.35
];

const getCurveY = (xPercent) => {
  const clamped = Math.max(0, Math.min(100, xPercent));
  const index = Math.floor(clamped);
  const frac = clamped - index;
  if (index >= 100) return CURVE_POINTS[100];
  return CURVE_POINTS[index] + frac * (CURVE_POINTS[index + 1] - CURVE_POINTS[index]);
};

const PeopelClip = () => {
  const [wordclipPath1, setWordclipPath1] = useState('inset(0 0% 0 0)');
  const [popele, setPopele] = useState(0);
  const [frame, setFrame] = useState(0);

  const container1 = useRef(null);

  const update = useCallback(() => {
    if (!container1.current) return;
    const bounds1 = container1.current.getBoundingClientRect();
    let percentage = Math.trunc(((bounds1.y * 12) / bounds1.height) * 4);

    if (percentage < 0) percentage = 0;
    if (percentage > 100) percentage = 100;

    // Frame cycling for spritesheet (using all 8 frames from the detailed image)
    const frames = 8;
    const newFrame = Math.floor(percentage / 0.5) % frames;

    setWordclipPath1(`inset(0 ${percentage}% 0 0)`);
    setPopele(percentage);
    setFrame(newFrame);
  }, []);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          update();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [update]);

  // Screen width responsive settings
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 560;
  const isTablet = typeof window !== 'undefined' && window.innerWidth <= 768;
  const offsetPx = isMobile ? 4 : (isTablet ? 6 : 10);
  const manWidth = isMobile ? 45 : (isTablet ? 60 : (typeof window !== 'undefined' && window.innerWidth <= 990 ? 75 : 90));
  const containerWidth = container1.current ? container1.current.offsetWidth : 1200;

  // Calculate the horizontal point of the feet (% from left of blue line image)
  const footX = Math.max(
    0,
    Math.min(100, 100 - popele - ((offsetPx + manWidth / 2) / (containerWidth || 1200)) * 100)
  );
  const yPercent = getCurveY(footX);

  return (
    <div
      className='popele'
      style={{ position: 'relative', overflowX: 'hidden' }}
      ref={container1}
      data-scroll-research
    >
      <div className='popele1'></div>
      <div
        className='popele2'
        style={{
          position: 'absolute',
          bottom: '0',
          left: 0,
          width: '100%'
        }}
      >
        <div style={{ width: '100%', height: '100%', clipPath: wordclipPath1 }}>
          <img
            src={img_walk_peopel2}
            alt=""
            style={{ width: '100%', height: '100%', display: 'block' }}
          />
        </div>
        <div
          className='popeleMan'
          style={{
            position: 'absolute',
            right: `calc(${popele}% + ${offsetPx}px)`,
            top: `${yPercent}%`,
            transform: 'translateY(-95%)',
            zIndex: 10,
            pointerEvents: 'none'
          }}
        >
          <img
            src={require(`../../images/walk_frame_${frame}.png`)}
            style={{
              height: '100%',
              width: '100%',
              objectFit: 'contain',
              display: 'block'
            }}
            alt="realistic walking sequence"
          />
        </div>
      </div>
    </div>
  );
};

export default PeopelClip;